import React from "react";

export default function SQL_Joins() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_Joins</h1>
      <p>This is the SQL_Joins component generated from the SQL JSON.</p>
    </div>
  );
}
